'use es6';

import { find, isTruthy } from '../../js-util';
const firstTruthy = find(isTruthy);

// if problem = null, there is no problem; action is enabled
export function getProblem(params, getAllProblems) {
  const allProblems = getAllProblems(params);
  return firstTruthy(allProblems);
}